import { useState } from "react";

import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { useConfirmDialogExit } from "hooks";
import { useSnackbar } from "providers/SnackbarProvider";
import {
  buttonAddSource,
  formAddSource,
  modalSourceSubTitle,
  modalSourceTitle,
  snackbarDataUploaded,
  snackbarSummarySourceAddSuccessSubTitlePart1,
  snackbarSummarySourceAddSuccessSubTitlePart2,
} from "_constants";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import { useAppDispatch } from "store/store";
import { setAddUserEmailValidation } from "store/slicer/FormAddUserValidationSlice";
import { setNameTopicValidation } from "store/slicer/FormTopicValidationSlice";
import { addSource } from "services";
import { SourceRequest } from "interfaces";
import { setPageSources } from "store/slicer/GestioneSourcesSlice";
import {
  setAddSourceNameValidation,
  setStatusUploadSource,
  StatusUploadSource,
} from "store/slicer/FormAddSourceValidationSlice";
import { FormSource } from "components/form/FormSource";

export const ButtonAddSource = () => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogExit } = useConfirmDialogExit();
  const showSingleStepDialog = () => {
    dispatch(setAddUserEmailValidation(true));
    resetFormState(false);
    setVisible(true);
  };

  const { handleSubmit, control, getValues, trigger, setValue, getFieldState } =
    useForm({
      defaultValues: {
        fileId: "",
        name: "",
        author: "",
        isbn: "",
        topicId: "",
      },
      shouldFocusError: false,
      mode: "onChange",
    });

  const onSubmit = (formData: any) => {
    const request: SourceRequest = {
      fileId: formData.fileId,
      name: formData.name,
      author: formData.author,
      isbn: formData.isbn ? formData.isbn : null,
      topicId: formData.topic.id,
    };
    addSource(request)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarDataUploaded,
          detail: `${snackbarSummarySourceAddSuccessSubTitlePart1}${getValues(
            "name"
          )}${snackbarSummarySourceAddSuccessSubTitlePart2}`,
          life: 5000,
        });
        dispatch(setPageSources(-1));
        setTimeout(() => {
          dispatch(setPageSources(1));
        }, 200);
        resetFormState(false);
      })
      .catch((error) => {
        if (error?.response?.status === 409) {
          dispatch(setNameTopicValidation(false));
        }
      });
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      const values = getValues();
      const isFormFilled = Object.values(values).some(
        (value) => value !== "" && value !== undefined
      );
      if (isFormFilled) {
        showConfirmDialogExit({ rejectCallback: resetFormState });
      } else {
        resetFormState();
      }
    } else {
      resetFormState();
    }
  };

  const resetFormState = (interruptUpload: boolean = true) => {
    if (interruptUpload) {
      dispatch(setStatusUploadSource(StatusUploadSource.CANCEL));
    }

    dispatch(setAddSourceNameValidation(true));
    control._reset();
    setVisible(false);
  };

  return (
    <>
      <Button
        label={buttonAddSource}
        icon={PrimeIcons.PLUS}
        onClick={showSingleStepDialog}
      />
      <SingleStepDialog
        onHideCallback={handleDismiss}
        minHeight="507px"
        width="700px"
        maxWidth="700px"
        size="auto"
        header={
          <SingleStepHeaders
            title={modalSourceTitle}
            subtitle={modalSourceSubTitle}
          />
        }
        body={
          <SingleStepBody
            content={
              <form
                id={formAddSource}
                onSubmit={handleSubmit(onSubmit)}
                className="width-100"
              >
                <FormSource
                  control={control}
                  getValues={getValues}
                  trigger={trigger}
                  setValue={setValue}
                  getFieldState={getFieldState}
                />
              </form>
            }
          />
        }
        footer={
          <SingleStepFooter dismiss={handleDismiss} form={formAddSource} />
        }
        display={visible}
        setVisible={setVisible}
      />
    </>
  );
};
